export const DOCUMENT_VIEWER = 'https://docs.google.com/gview';
